import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as Cookies from 'es-cookie';
import { SessionKeys } from '../enums/session-keys.enums';

@Injectable()
export class ImpersonationInterceptor implements HttpInterceptor {
	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		if (!request.url.includes('/api')) {
			return next.handle(request);
		}

		if (Cookies.get(SessionKeys.IMPERSONATION_COOKIE)) {
			return next.handle(this.addImpersonationHeader(request));
		}

		return next.handle(request);
	}

	private addImpersonationHeader(request: HttpRequest<unknown>): HttpRequest<unknown> {
		const headers = request.headers
			.append('impersonation-user', Cookies.get(SessionKeys.IMPERSONATION_COOKIE))
			.append('impersonation-user-type', 'staff')
			.append('impersonation-application', 'mynha');

		const impersonationRequest: HttpRequest<unknown> = request.clone({
			headers: headers
		});

		return impersonationRequest;
	}
}
